import * as React from "react";
import { Collapse, CollapseProps } from "antd";

/**
 * @param props : Provide isOpen: boolean to show/hide component
 */
export const ControlledCollapse: React.FunctionComponent<{ isOpen: boolean; children: React.ReactNode }> = (props) => {
  const activeKey = props.isOpen ? "1" : "";

  const items: CollapseProps["items"] = [
    {
      key: "1",
      label: "",
      children: props.children,
      collapsible: activeKey ? undefined : "disabled",
    },
  ];

  return <Collapse activeKey={activeKey} items={items} className="collapse-hidden" />;
};
